import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_get_completed_orders_without_attachmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { type_id: number, completed_on: string, order_id?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.type_id)) {
      $missingRequiredInParams.push('\'type_id\'');
    }
    if (isNil($inParams.completed_on)) {
      $missingRequiredInParams.push('\'completed_on\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { type_id: number, completed_on: string, order_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.type_id)) {
      $missingRequiredInParams.push('\'type_id\'');
    }
    if (isNil($inParams.completed_on)) {
      $missingRequiredInParams.push('\'completed_on\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { type_id: number, completed_on: string, order_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.type_id)) {
      $missingRequiredInParams.push('\'type_id\'');
    }
    if (isNil($inParams.completed_on)) {
      $missingRequiredInParams.push('\'completed_on\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      type_id: number, completed_on: string, order_id?: number    }) {
        if(isNil($inParams.type_id)) {
          return true; 
        }
        if(isNil($inParams.completed_on)) {
          return true; 
        }
      return false;
    }
}
